<template>
  <a-modal
    class="paper-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="questionVisible"
    :destroy-on-close="true"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <a-form
      :form="form"
    >
      <a-row>
		 
        <a-col :span="24">
          <a-form-item
            label="问题名称"
            :label-col="{span:4}"
            :wrapper-col="{span:18}"
            :colon="false"
          >
            <a-input
              v-decorator="[
                'paper_title',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入问题名称',
                    },
                  ],

                },
              ]"
              placeholder="请输入问题名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="问题类型"
            :label-col="{span:4,}"
            :wrapper-col="{span:18}"
            :colon="false"
          >
            <a-select
              v-decorator="[
                'paper_type',
                { rules: [{ required: true, message: '请选择问题类型' }], },
              ]"
              placeholder="请选择问题类型"
            >
              <a-select-option
                v-for="item in paperData"
                :key="item.key"
                :value="item.key"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col
          v-for="(item,index) in formData1.data"
          :key="item.uid"
          :span="24"
        >
          <a-form-item
            class="option-class"
            label="问题选项"
            :label-col="{span:4,}"
            :wrapper-col="{span:18}"
            :colon="false"
          >
            <option-answer
              v-decorator="[
                `${item.uid}`,
                { rules: [{ required: true, message: '请输入问题选项' }],},
              ]"
            />
            <a-icon
              v-show="formData1.data.length>1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              @click="remove(item)"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            :wrapper-col="{span:18 ,offset:4}"
            :colon="false"
          >
            <a-button
              type="dashed"
              style="width: 100%"
              @click="add"
            >
              <a-icon type="plus" /> 增加选项
            </a-button>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="问题分数"
            :label-col="{span:4}"
            :wrapper-col="{span:18}"
            :colon="false"
          >
            <a-input
              v-decorator="[
                'score',
                { rules: [{ required: true, message: '请输入分数' }], },
              ]"
              placeholder="请输入分数"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="错误原因"
            :label-col="{span:4}"
            :wrapper-col="{span:18}"
            :colon="false"
          >
            <a-textarea
              v-decorator="[
                'err_msg',
                { rules: [{ required: true, message: '请输入错误原因' }] , },
              ]"
              rows="6"
              placeholder="请输入错误原因"
              maxlength="150"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <slot />
    </a-form>
  </a-modal>
</template>

<script>
const uuidv1 = require('uuid/v1');
import OptionAnswer from './../components/optionAnswer';
export default {
  components: {OptionAnswer},
  props: ['questionVisible', 'title', 'showErrorMsg', 'formData', 'showAnswerMsg'],
  data() {
    return {
      paperData: [{
        key: 1, name: '单选',
      },
      {
        key: 2, name: '多选',
      },
      ],
      formData1: {
        paper_title: undefined,
        paper_type: undefined,
        score: undefined,
        err_msg: undefined,
        data: [{uid: uuidv1(), options: '', answers: ''}],
      },


    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    console.log(this);

  },
  methods: {
    initData(){
      this.formData1 = {
        data: [{uid: uuidv1(), options: '', answers: ''}],
      };
    },
    updateData(data){
      this.formData1.data = JSON.parse(JSON.stringify(data));
    },
    // 增加选项
    add(key){

      this.formData1.data.push({uid: uuidv1(), options: undefined, answers: undefined});
    },
    // 移除
    remove(key){
      this.formData1.data=this.formData1.data.filter((item, index)=>item!==key);
      // this.form.setFieldsValue(this.formData1);
      console.log('remove -> this.formData1.data', this.formData1.data);
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-modal-wrapper {
  .option-class /deep/ .ant-form-item-control{
    line-height:unset;
  }
  .error-msg{
    color: #f5222d;
    margin-left: 109px;
  }
  .dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: -25px;
  left: 462px;
  font-size: 18px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

}
</style>
